import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

import type { SpaceAdapterResourceTypeInputSpec } from '@toolproof-core/visualization/adapter/_contract/adapter';

import { RESOURCE_TYPE_REQUIREMENTS } from '@/adapters/primitive/_data/config/fragments/resourceTypes';

export const RESOURCE_TYPE_INPUT_SPEC = {
    requiredResourceTypes: RESOURCE_TYPE_REQUIREMENTS,
} as const satisfies SpaceAdapterResourceTypeInputSpec<ResourceTypeHandle>;

export function getResourceTypeInputSpec() {
    return RESOURCE_TYPE_INPUT_SPEC;
}
